import { render, staticRenderFns } from "./Convergists.vue?vue&type=template&id=f21e8ca2&scoped=true"
import script from "./Convergists.vue?vue&type=script&lang=ts"
export * from "./Convergists.vue?vue&type=script&lang=ts"
import style0 from "./Convergists.vue?vue&type=style&index=0&id=f21e8ca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21e8ca2",
  null
  
)

export default component.exports